import React, { useContext } from 'react'
import { ChangePresentContext, OpsPlanContext } from '../../../SingleEvent'
import { Grid } from '@mui/material'
import StaffSelector from '../../../../StaffSelector'

const OpsManager = () => {
  const { opsPlan, setOpsPlan } = useContext(OpsPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12} lg={6}>
      <StaffSelector
        value={opsPlan?.opsManager ?? null}
        onChange={(e, value) => {
          setOpsPlan((prev) => ({
            ...prev,
            opsManager: value,
          }))
          !changesPresent && setChangesPresent(true)
        }}
        shrinkLabel={!!opsPlan?.opsManager}
        label="Ops Manager"
      />
    </Grid>
  )
}

export default React.memo(OpsManager)
